import type { AssessmentQuestion } from '@ts-assessment/interfaces'

import imgQuestion3 from '@images/assessment/questions/math/grade-k2/question-3.png'
import imgQuestion5 from '@images/assessment/questions/math/grade-k2/question-5.png'
import imgQuestion8 from '@images/assessment/questions/math/grade-k2/question-8.png'
import imgQuestion9 from '@images/assessment/questions/math/grade-k2/question-9.png'
import imgQuestion11 from '@images/assessment/questions/math/grade-k2/question-11.png'

export const questions: AssessmentQuestion[] = [
  {
    name: 'grade_k2_1',
    title: 'If the difference of 74 - 32 = 42, which addition sum is the reverse of this difference?',
    topic: 'Sums and differences to 100',
    answers: [
      {
        name: 'grade_k2_1_a',
        text: '42 - 32',
      },
      {
        name: 'grade_k2_1_b',
        text: '42 +42',
      },
      {
        name: 'grade_k2_1_c',
        text: '32 - 32',
      },
      {
        name: 'grade_k2_1_d',
        text: '32 + 42',
        correct: true,
      },
    ],
  },
  {
    name: 'grade_k2_2',
    title: 'A number has 3 ones, 8 tens, 0 hundreds, and 6 thousands. What is that number?',
    topic: 'Place Value',
    answers: [
      {
        name: 'grade_k2_2_a',
        text: '6308',
      },
      {
        name: 'grade_k2_2_b',
        text: '6083',
        correct: true,
      },
      {
        name: 'grade_k2_2_c',
        text: '3680',
      },
      {
        name: 'grade_k2_2_d',
        text: '8063',
      },
    ],
  },
  {
    name: 'grade_k2_3',
    title: 'Find out the missing number in the comparison.',
    topic: 'Number Comparison',
    image: imgQuestion3,
    answers: [
      {
        name: 'grade_k2_3_a',
        text: '612',
        correct: true,
      },
      {
        name: 'grade_k2_3_b',
        text: '968',
      },
      {
        name: 'grade_k2_3_c',
        text: '119',
      },
      {
        name: 'grade_k2_3_d',
        text: '803',
      },
    ],
  },
  {
    name: 'grade_k2_4',
    title: 'If we add 723 to 276 and then subtract 333, the answer we get is:',
    topic: 'Addition - Subtraction 2-Step Problems',
    answers: [
      {
        name: 'grade_k2_4_a',
        text: '666',
        correct: true,
      },
      {
        name: 'grade_k2_4_b',
        text: '555',
      },
      {
        name: 'grade_k2_4_c',
        text: '777',
      },
      {
        name: 'grade_k2_4_d',
        text: '999',
      },
    ],
  },
  {
    name: 'grade_k2_5',
    title: 'John has 4 pencils. What is the difference between the longest and the shortest pencil?',
    topic: 'Addition - Subtraction of Length Units',
    image: imgQuestion5,
    answers: [
      {
        name: 'grade_k2_5_a',
        text: '7 cm',
      },
      {
        name: 'grade_k2_5_b',
        text: '6 cm',
      },
      {
        name: 'grade_k2_5_c',
        text: '5 cm',
      },
      {
        name: 'grade_k2_5_d',
        text: '8 cm',
        correct: true,
      },
    ],
  },
  {
    name: 'grade_k2_6',
    title: 'Riz walked 650 m from his house to the shop. Then he walked further 330 m to reach his school. How long did Riz walk from his house to the school?',
    topic: 'Addition - Subtraction of Length Units',
    answers: [
      {
        name: 'grade_k2_6_a',
        text: '890 m',
      },
      {
        name: 'grade_k2_6_b',
        text: '800 m',
      },
      {
        name: 'grade_k2_6_c',
        text: '980 m',
        correct: true,
      },
      {
        name: 'grade_k2_6_d',
        text: '750 m',
      },
    ],
  },
  {
    name: 'grade_k2_7',
    title: 'Mina boiled the rice for her brother. She started cooking at 5:30 and ended at 6:00. How much time did she take to cook the rice?',
    topic: 'Time Calculation',
    answers: [
      {
        name: 'grade_k2_7_a',
        text: '20 minutes',
      },
      {
        name: 'grade_k2_7_b',
        text: '30 minutes',
        correct: true,
      },
      {
        name: 'grade_k2_7_c',
        text: '15 minutes',
      },
      {
        name: 'grade_k2_7_d',
        text: '25 minutes',
      },
    ],
  },
  {
    name: 'grade_k2_8',
    title: 'Which shape has 5 faces?',
    topic: 'Geometry',
    image: imgQuestion8,
    answers: [
      {
        name: 'grade_k2_8_a',
        text: 'b',
      },
      {
        name: 'grade_k2_8_b',
        text: 'a',
        correct: true,
      },
      {
        name: 'grade_k2_8_c',
        text: 'c',
      },
      {
        name: 'grade_k2_8_d',
        text: 'a and b',
      },
    ],
  },
  {
    name: 'grade_k2_9',
    title: 'How many parts will you color to get the fraction 3/4?',
    topic: 'Fractions',
    image: imgQuestion9,
    answers: [
      {
        name: 'grade_k2_9_a',
        text: '2',
      },
      {
        name: 'grade_k2_9_b',
        text: '1',
      },
      {
        name: 'grade_k2_9_c',
        text: '4',
      },
      {
        name: 'grade_k2_9_d',
        text: '3',
        correct: true,
      },
    ],
  },
  {
    name: 'grade_k2_10',
    title: 'If 4 + 4 + 4 + 4 = 16, which expression has the same results?',
    topic: 'Foundations of Multiplication and Division',
    answers: [
      {
        name: 'grade_k2_10_a',
        text: '4 + 4',
      },
      {
        name: 'grade_k2_10_b',
        text: '4 - 4',
      },
      {
        name: 'grade_k2_10_c',
        text: '4 × 4',
        correct: true,
      },
      {
        name: 'grade_k2_10_d',
        text: '4 = 4',
      },
    ],
  },
  {
    name: 'grade_k2_11',
    title: 'There are 12 eggs and 6 baskets. How many eggs will you put equally in each basket?',
    topic: 'Foundations of Multiplication and Division',
    image: imgQuestion11,
    answers: [
      {
        name: 'grade_k2_11_a',
        text: '3',
      },
      {
        name: 'grade_k2_11_b',
        text: '4',
      },
      {
        name: 'grade_k2_11_c',
        text: '2',
        correct: true,
      },
      {
        name: 'grade_k2_11_d',
        text: '6',
      },
    ],
  },
  {
    name: 'grade_k2_12',
    title: 'A toy bear costs $20. Which group of money CANNOT buy that toy?',
    topic: 'Counting Money',
    answers: [
      {
        name: 'grade_k2_12_a',
        text: 'Three $5 notes',
        correct: true,
      },
      {
        name: 'grade_k2_12_b',
        text: 'Two $5 + One $10 notes',
      },
      {
        name: 'grade_k2_12_c',
        text: 'Two $10 notes',
      },
      {
        name: 'grade_k2_12_d',
        text: 'Four $5 notes',
      },
    ],
  },
]
